var _rect, _path, _g, _g2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotCompare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1934_913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 19,
    height: 14
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1934_913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 19,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14355,
    y: 8.00021,
    width: 16.8565,
    height: 11,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9292 15.9377L9.64332 13.094L11.2147 15.5315L18.2859 11.469L22.2143 16.344",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1934_913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69141 5.93549H24.0478V21.103H3.69141V5.93549Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1934_913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0007 6.50095H13.4355L13.4355 11.9998L13.4355 17.0009H1.00073L1.00073 20.5009H23.0007V6.50095Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56226 6.00027C4.15545 6.00027 3.58806 6.00029 3.09523 6.00027L3.09523 7.40067L1.00007 7.40067L1.00007 4.00027L4.56226 4.00027L4.56226 6.00027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91431 12.0002C8.32111 12.0002 8.8885 12.0002 9.38133 12.0002L9.38133 10.5998L11.4765 10.5998L11.4765 14.0002L7.91431 14.0002L7.91431 12.0002Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38042 7.40021C9.38042 7.01188 9.38041 6.47026 9.38042 5.99982L7.9134 5.99982L7.9134 3.99982L11.4756 3.99982L11.4756 7.40021L9.38042 7.40021Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09541 10.6002C3.09541 10.9885 3.09542 11.5301 3.09541 12.0005H4.56243V14.0005H1.00024L1.00024 10.6002H3.09541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotCompare2);
export default __webpack_public_path__ + "static/media/Spot_Compare2.4a43ada4369890714a11429d6b088c07.svg";
export { ForwardRef as ReactComponent };